export default __webpack_public_path__ + "static/media/FLove.4943c7c4.svg";